<ng-template #quantity>
  <span>{{ _quantity}}</span>
  <ng-content></ng-content>
</ng-template>

<div class="flex flex-row bg-e-white rounded-full h-full w-full " [ngClass]="colorscheme">
  @if (editable) {
    <button class="disabled:opacity-25 w-1/4 my-auto" aria-label="{{'common.reduce_quantity' | translate}}" [ngClass]="{'h-[35px]': !_small, 'h-[26px]': _small}" [disabled]="_quantity === min" (click)="changeQty(-1)" id="minusqty">
      <i class="bi bi-dash text-xl" [ngClass]="{'leading-[35px]': !_small, 'leading-[26px]': _small}"></i>
    </button>
    <small class="flex gap-1 flex-row flex-nowrap justify-center w-1/2 my-auto" [ngClass]="{'leading-[35px]': !_small, 'leading-[26px]': _small}">
      <ng-container *ngTemplateOutlet="quantity"></ng-container>
    </small>
    <button class="disabled:opacity-25 w-1/4 my-auto" aria-label="{{'common.increase_quantity' | translate}}" [ngClass]="{'h-[35px]': !_small, 'h-[26px]': _small}" [disabled]="_quantity === max" (click)="changeQty(1)" id="plusqty">
      <i class="bi bi-plus text-xl" [ngClass]="{'leading-[35px]': !_small, 'leading-[26px]': _small}"></i>
    </button>
  }
  @if (!editable) {
    <small class="flex gap-1 flex-row flex-nowrap justify-center w-full my-auto" [ngClass]="{'leading-[35px]': !_small, 'leading-[26px]': _small}">
      <ng-container *ngTemplateOutlet="quantity"></ng-container>
    </small>
  }
</div>
